module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_summersale_small_de-98743abed207993e851591423de8ede3.jpg";